export default [
  {
    title: 'مدیریت سفارش ها',
    icon: 'bx bx-store',
    children: [
      {
        title: 'رژیم',
        route: { name: 'userdietorder' },
        resource: 'OrderView',
        action: 'show',
      },
      {
        title: 'ورزش',
        route: { name: 'activitypackageorder' },
        resource: 'OrderView',
        action: 'show',
      },
      {
        title: 'تخفیف',
        route: { name: 'discount' },
        resource: 'CouponManager',
        action: 'show',
      },
      {
       title: 'لیست تماس ها',
       route: {name: 'callCenterRequest'},
       resource: 'UserCallRequestManager',
       action: 'show',
      },
      {
        title: ' کافه بازار',
        route: { name: 'billsCafeBazar' },
        resource: 'OrderManager',
        action: 'show',
      },
      {
        title: 'زرین پال',
        route: { name: 'billsZarinPal' },
        resource: 'UserManager',
        action: 'show',
      },
    ],
  },
]
